'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MobileMenu = exports.MOBILE_MENU_SELECTOR = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MOBILE_MENU_SELECTOR = exports.MOBILE_MENU_SELECTOR = '[data-mobile-menu]'; /*
                                                                                 *  Mobile Menu
                                                                                 *    Scripts for the mobile menu
                                                                                 *
                                                                                 *  Version:
                                                                                 *    1.0.0 - 2020/07/02
                                                                                 */

var MOBILE_MENU_TOGGLE = '[data-mobile-menu-toggle]';
var MOBILE_MENU_DROPDOWN = '[data-mobile-menu-dropdown]';
var MOBILE_MENU_SUBMENU = '[data-mobile-submenu]';
var MOBILE_MENU_SUBSUBMENU = '[data-mobile-subsubmenu]';
var MOBILE_MENU_SUBSUBSUBMENU = '[data-mobile-subsubsubmenu]';

var MOBILE_SUBMENU_TOGGLE = '[data-mobile-submenu-toggle]';
var MOBILE_SUBSUBMENU_TOGGLE = '[data-mobile-subsubmenu-toggle]';
var MOBILE_SUBSUBSUBMENU_TOGGLE = '[data-mobile-subsubsubmenu-toggle]';

var CLASS_MENU_OPEN = 'is-menu-open';
var CLASS_SUBMENU_OPEN = 'is-submenu-open';
var CLASS_SUBSUBMENU_OPEN = 'is-subsubmenu-open';
var CLASS_SUBSUBSUBMENU_OPEN = 'is-subsubsubmenu-open';

var MobileMenu = exports.MobileMenu = function () {
  function MobileMenu(container) {
    var _this = this;

    (0, _classCallCheck3.default)(this, MobileMenu);

    this.container = container;
    this.menuTargets = [container, (0, _jquery2.default)('html,body')];
    this.menuDropdown = container.find(MOBILE_MENU_DROPDOWN);
    this.submenu = container.find(MOBILE_MENU_SUBMENU);
    this.subsubmenu = container.find(MOBILE_MENU_SUBSUBMENU);
    this.subsubsubmenu = container.find(MOBILE_MENU_SUBSUBSUBMENU);

    container.on('click touch', MOBILE_MENU_TOGGLE, function (e) {
      return _this.onMenuToggle(e);
    });
    container.on('click touch', MOBILE_SUBMENU_TOGGLE, function (e) {
      return _this.onSubmenuToggle(e);
    });
    container.on('click touch', MOBILE_SUBSUBMENU_TOGGLE, function (e) {
      return _this.onSubSubmenuToggle(e);
    });
    container.on('click touch', MOBILE_SUBSUBSUBMENU_TOGGLE, function (e) {
      return _this.onSubSubSubmenuToggle(e);
    });
    (0, _jquery2.default)(window).on('resize orientationchange', function () {
      return _this.onResize();
    });
    this.onResize();
  }

  (0, _createClass3.default)(MobileMenu, [{
    key: 'open',
    value: function open() {
      this.menuTargets.forEach(function (e) {
        return e.addClass(CLASS_MENU_OPEN);
      });
    }
  }, {
    key: 'close',
    value: function close() {
      var _this2 = this;

      this.menuTargets.forEach(function (e) {
        return e.removeClass(CLASS_MENU_OPEN);
      });

      //Reset the sub and subsub menus after a short delay
      setTimeout(function () {
        _this2.submenu.removeClass(CLASS_SUBMENU_OPEN);
        _this2.subsubmenu.removeClass(CLASS_SUBSUBMENU_OPEN);
      }, 500);
    }
  }, {
    key: 'toggleOpen',
    value: function toggleOpen() {
      if (this.container.hasClass(CLASS_MENU_OPEN)) return this.close();
      this.open();
    }
  }, {
    key: 'onMenuToggle',
    value: function onMenuToggle(e) {
      this.cancelEvents(e) && this.toggleOpen();
    }
  }, {
    key: 'onSubmenuToggle',
    value: function onSubmenuToggle(e) {
      this.cancelEvents(e);
      var subToggle = (0, _jquery2.default)(e.currentTarget);
      var submenu = subToggle.next(MOBILE_MENU_SUBMENU);

      if (submenu.hasClass(CLASS_SUBMENU_OPEN)) {
        subToggle.removeClass(CLASS_SUBMENU_OPEN);
        submenu.removeClass(CLASS_SUBMENU_OPEN);
        return;
      }

      subToggle.addClass(CLASS_SUBMENU_OPEN);
      submenu.addClass(CLASS_SUBMENU_OPEN);
    }
  }, {
    key: 'onSubSubmenuToggle',
    value: function onSubSubmenuToggle(e) {
      this.cancelEvents(e);
      var subToggle = (0, _jquery2.default)(e.currentTarget);
      var submenu = subToggle.next(MOBILE_MENU_SUBSUBMENU);

      if (submenu.hasClass(CLASS_SUBSUBMENU_OPEN)) {
        subToggle.removeClass(CLASS_SUBSUBMENU_OPEN);
        submenu.removeClass(CLASS_SUBSUBMENU_OPEN);
        return;
      }

      subToggle.addClass(CLASS_SUBSUBMENU_OPEN);
      submenu.addClass(CLASS_SUBSUBMENU_OPEN);
    }
  }, {
    key: 'onSubSubSubmenuToggle',
    value: function onSubSubSubmenuToggle(e) {
      this.cancelEvents(e);
      var subToggle = (0, _jquery2.default)(e.currentTarget);
      var submenu = subToggle.next(MOBILE_MENU_SUBSUBSUBMENU);

      if (submenu.hasClass(CLASS_SUBSUBSUBMENU_OPEN)) {
        subToggle.removeClass(CLASS_SUBSUBSUBMENU_OPEN);
        submenu.removeClass(CLASS_SUBSUBSUBMENU_OPEN);
        return;
      }

      subToggle.addClass(CLASS_SUBSUBSUBMENU_OPEN);
      submenu.addClass(CLASS_SUBSUBSUBMENU_OPEN);
    }
  }, {
    key: 'cancelEvents',
    value: function cancelEvents(e) {
      e.preventDefault(), e.stopPropagation();
      return true;
    }
  }, {
    key: 'onResize',
    value: function onResize() {
      var menuDropdownTop = (0, _jquery2.default)('[data-search-bar]').offset().top + (0, _jquery2.default)('[data-search-bar]').height();
      this.menuDropdown.css('top', menuDropdownTop);
    }
  }]);
  return MobileMenu;
}();